import React from 'react'
import {useTranslation} from 'react-i18next'
import {isMobile} from 'react-device-detect'
import styled from 'styled-components'

const Option = styled.span`
  &:hover {
    color: var(--bs-primary);
  }

`

const TourTypesFilter = (props) => {
  const {machine} = props
  const [current, send] = machine
  const {i18n} = useTranslation()

  const tourTypes = [
    { label: i18n.t('tour_types_filter.regular_group'), value: 'regular_group' },
    { label: i18n.t('tour_types_filter.small_group'), value: 'small_group' },
    { label: i18n.t('tour_types_filter.private_group'), value: 'private_group' },
    // { label: i18n.t('tour_types_filter.tailor_made'), value: 'tailor_made' },
    { label: i18n.t('tour_types_filter.hop_on_hop_off'), value: 'hop_on_hop_off' },
    { label: i18n.t('tour_types_filter.self_guided'), value: 'self_guided' }
  ]

  const tourTypeFilterd = current.context.filters.find(
    (filter) => filter.param === 'tour_type'
  )
  const tourTypeFilterValue = tourTypeFilterd && tourTypeFilterd.value

  const onTourTypeFilter = (tourType) => {
    if (tourTypeFilterValue === tourType.value) {
      send({ type: 'FILTER_REMOVE', param: 'tour_type' })
    } else {
      send({
        type: 'FILTER_SELECTION',
        filter: {
          param: 'tour_type',
          label: tourType.label,
          value: tourType.value
        }
      })
    }

    if (isMobile) {
      props.setIsOpen(!props.isOpen)
    }
  }

  return (
    <>
      {tourTypes.map((tourType) => (
        <div key={tourType.value} className="mb-1">
          <input
            type="radio"
            className="me-2"
            checked={tourType.value === tourTypeFilterValue}
            onChange={() => onTourTypeFilter(tourType)}
            style={{ cursor: 'pointer' }}
          />
          <label
            onClick={() => onTourTypeFilter(tourType)}
            style={{ cursor: 'pointer' }}
          >
            <Option className={tourType.value === tourTypeFilterValue ? 'fw-semibold' : 'fw-normal'}>{tourType.label}</Option>
          </label>
        </div>
      ))}
    </>
  )
}

export default TourTypesFilter
